import React from 'react';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ComingSoon = ({ title = "Coming Soon", description = "This feature is under development" }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.1) 100%)',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 6,
            borderRadius: 4,
            textAlign: 'center',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(0,0,0,0.06)',
          }}
        >
          {/* Icon Section */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              mb: 4,
            }}
          >
            <Box
              sx={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 8px 24px rgba(102, 126, 234, 0.3)',
                animation: 'pulse 2s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': {
                    transform: 'scale(1)',
                    boxShadow: '0 8px 24px rgba(102, 126, 234, 0.3)',
                  },
                  '50%': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 12px 32px rgba(102, 126, 234, 0.4)',
                  },
                },
              }}
            >
              <RocketLaunchIcon sx={{ fontSize: 50, color: '#fff' }} />
            </Box>
          </Box>

          {/* Text Section */}
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              mb: 2,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#4a5568',
              mb: 1,
              fontWeight: 500,
            }}
          >
            We're working on something amazing!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#718096',
              mb: 4,
              lineHeight: 1.8,
            }}
          >
            {description}. Stay tuned for exciting updates.
          </Typography>

          {/* Construction Icon */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mb: 4,
              color: '#667eea',
            }}
          >
            <ConstructionIcon sx={{ fontSize: 24 }} />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Under Construction
            </Typography>
            <ConstructionIcon sx={{ fontSize: 24 }} />
          </Box>

          {/* Back Button */}
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/dashboard')}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontSize: '1rem',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                transition: 'all 0.2s',
              },
            }}
          >
            Back to Dashboard
          </Button>

          {/* Additional Info */}
          <Box
            sx={{
              mt: 4,
              pt: 3,
              borderTop: '1px solid rgba(0,0,0,0.06)',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: '#a0aec0',
                fontSize: '0.85rem',
              }}
            >
              Expected Launch: Q1 2025
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ComingSoon;